export default __webpack_public_path__ + "static/fhe-39d4c55b327564e8cabfc5d01b178068.webp";